import {encrypt, getData} from "./util";
import {observableStore} from "./obvStore";
export function enc(s) {
    return encrypt(s, '90R1XU#DEDghEObz', '&$n$^VGfTT%VDdeX');
}
export function convertDate(date, format = 'YYYY-MM-DD') {
    if (!date) return '---';
    date = new Date(date);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    return format
        .replace(/Y+/, year)
        .replace(/M+/, (100 + month + '').substr(1))
        .replace(/D+/, (100 + day + '').substr(1))
        .replace(/h+/, (100 + hour + '').substr(1))
        .replace(/m+/, (100 + minute + '').substr(1))
        .replace(/s+/, (100 + second + '').substr(1));
};

const k = {
    count: 0,
    loading: false,
    load() {
        getData('@/withdraw/withdraw-count', undefined,
            data => {
                this.count = data.iWithdrawalNum;
            },
            0, 'POST'
        )
    }
};
export const withdrawStore = observableStore('_wd',k);

const mp = {};
export const banksStore = observableStore('_bk', {
    cards: [],
    usdts: [],
    myCard: [],
    get bankMap() {
        return mp;
    },
    set bankMap(v) {
        if (Array.isArray(v)) {
            this.cards=v;
            v.forEach(n => {
                mp[n.id] = n
            })
        }
    }
});

const o = {
    render: null,
    type: 'confirm',
    title: '提示消息',
    msg: '',
    btnVal: '确定',
    extraVal: '',
    justSure: '',
    cancelBtnVal: '取消',
    isShow: false,
    cls:'',
    cancelHandle:()=>0,
    sureHandle: () => 0,
    delHandle: () => 0
}

export const alert = observableStore('_alt_', {
    ...o,
    cancelHandle() {
        alert.hide()
    },
    show(cfg) {
        if(cfg.msg==='Aborted')return ;
        Object.assign(this, o, cfg, {isShow: true});
    },
    hide() {
        Object.assign(this, o)
    }
});

